import React, { useEffect, useState } from "react";
import { withRouter, useParams, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getPurchasesStats, getConsumptionsStats, getCreditMovements, setCreditFilters } from "../../redux/actions/stats";
import { getUser, postUser, signOut, deleteAccount } from "../../redux/actions/users";
import { getAllEvents } from "../../redux/actions/events";
import AccountAside from "../navigation/accountAside";
import AccountBasicData from "../../pages/account/accountBasicData";
import AccountCredit from "../../pages/account/accountCredit";
import { useTranslation } from 'react-i18next';
import axiosInstance from "../../services/api";
import AccountPhotoSale from "../../pages/account/accountPhotoSale";
import { RevPageHead } from "../ds";

const AccountContainer = ({ user, events, getUser, purchasesData, consumptionsData, creditMovements, creditFilters, getPurchasesStats, getConsumptionsStats, getCreditMovements, setCreditFilters, getAllEvents, loadingPurchases, loadingConsumptions, loadingCreditMovements, loadingUser, postUser, signOut, deleteAccount }) => {

    const { t, i18n } = useTranslation();
    let { mode, redirect } = useParams();
    const [stripePayments, setStripePayments] = useState(undefined);

    useEffect(() => {
        if (!user) getUser();
        if (events?.length < 1) getAllEvents();
        // credit y purchases se realizan directamente en hook de cada componente
        if(mode === "payments") {
            if (!stripePayments) {

                try {
                    axiosInstance.get('/stripe-payments').then((res) => {
                        setStripePayments(res.data);
                    }).catch((e) => {
                        console.error(e);
                        setStripePayments([]);
                    });
                } catch (e) {
                    console.error(e);
                    setStripePayments([]);
                }
            }
        }
    // eslint-disable-next-line
    }, [mode]);

    useEffect(() => {
        if (user?.lang && i18n.language !== user?.lang) {
            i18n.changeLanguage(user?.lang);
        }
    }, [user, i18n]);

    return (
        <main className="rev-page">
            <RevPageHead className="rev-pagehead--tabs" title={t('account.title')} />
            <AccountAside mode={mode} />
            <div className="rev-page__content">
                    {mode === "basic" && <AccountBasicData redirect={redirect} user={user} loading={loadingUser} postUser={postUser} signOut={signOut} deleteAccount={deleteAccount} events={events} getUser={getUser}/>}
                    {(mode === "credit" || mode === "consumptions") && <AccountCredit
                        mode={mode}
                        redirect={redirect}
                        user={user}
                        events={events}
                        purchasesData={purchasesData}
                        getPurchasesStats={getPurchasesStats}
                        loadingPurchases={loadingPurchases}
                        consumptionsData={consumptionsData}
                        getConsumptionsStats={getConsumptionsStats}
                        loadingConsumptions={loadingConsumptions}
                        creditMovements={creditMovements}
                        getCreditMovements={getCreditMovements}
                        loadingCreditMovements={loadingCreditMovements}
                        creditFilters={creditFilters}
                        setCreditFilters={setCreditFilters} />}
                    {mode === "photo-sale" && <AccountPhotoSale user={user} loadingUser={loadingUser} postUser={postUser} events={events} getUser={getUser} />}
                    {/* Los cupones se gestionan en cada evento (/events/:id/coupons); los marcadores viejos siguen llegando */}
                    {mode === "coupons" && <Redirect to="/events" />}
            </div>
        </main>
    );
};

const mapStateToProps = state => (
    {
        user: state.usersReducer.user,
        events: state.eventsReducer.events,
        purchasesData: state.statsReducer.purchasesData,
        consumptionsData: state.statsReducer.consumptionsData,
        creditMovements: state.statsReducer.creditMovements,
        creditFilters: state.statsReducer.creditFilters,
        loadingUser: state.usersReducer.loading,
        loadingPurchases: state.statsReducer.loadingPurchases,
        loadingConsumptions: state.statsReducer.loadingConsumptions,
        loadingCreditMovements: state.statsReducer.loadingCreditMovements,
    }
);

const mapDispatchToProps =
{
    getUser,
    getAllEvents,
    postUser,
    getPurchasesStats,
    getConsumptionsStats,
    getCreditMovements,
    setCreditFilters,
    deleteAccount,
    signOut
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountContainer));
